import { Flex, styled } from '@withjoy/joykit';

export const Container = styled(Flex)`
  align-items: center;
  column-gap: 0.5rem;
  flex-direction: column;
  padding-top: 1.5rem;
  row-gap: 0.5rem;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    padding-top: 3rem;
  }
`;

export const LogoContainer = styled.div`
  margin-bottom: 1rem;
`;
